import React, { Component } from 'react';
import _ from 'lodash';

// Import the CSS
import '../../scss/_icons.scss';
import '../../scss/components/_inline-alert.scss';

export default class InlineAlert extends Component {

	componentDidMount() {
		// window.setTimeout(function() {
		// 	this.refs.alert.setAttribute("class","hidden");
		// }.bind(this), 8000);
	}

	dismiss (element) {
		element.target.setAttribute("class", "hidden");
	}

	render () {
		if (this.props.success) {
			return (<div ref="alert" className="success icon-check-circle" onClick={this.dismiss} ></div>);
		} else {
			return (<div ref="alert" className="error icon-warning-circle" onClick={this.dismiss} ></div>);
		}
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/components/InlineAlert.js